import React from "react"

export default function ProhibitedBusinessVerticalsSubtitle() {
	return (
		<>
			If a new application is created with a business vertical selected below, the application will be automatically
			denied.
			<br />
			If an existing customer is associated with a prohibited business vertical, they will be unable to open any new
			account(s).
		</>
	)
}
